import { Injectable } from '@angular/core';
import { AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { StateService } from 'app/core/state.service';
import { AuthService } from './auth.service';
import { Registrant } from '../pages/checkit-dashboard/checkit.model';
import * as jsPDF from 'jspdf';
import { FontsBase64 } from './fonts.base64';
import { DatePipe } from '@angular/common';

@Injectable()
export class DownloadService {
    registrantCollection: AngularFirestoreCollection<Registrant>;
    registrants: Observable<Registrant[]>;

    constructor(private state: StateService, private auth: AuthService, private fonts: FontsBase64) {
        if (this.state.accounts['currentId'] && this.state.checkit.event && this.state.checkit.event.hasOwnProperty('eventId')  ){
            this.registrantCollection = this.auth.afs.collection<Registrant>(`accounts/${this.state.accounts['currentId']}/registrants`,
                ref => { return ref.where("eventId", '==' , this.state.checkit.event['eventId']); }
            );
            this.registrants = this.registrantCollection.valueChanges();
        }
    }

    forBadges(title) {
        const width = 90;
        const height = 55;
        const name_pos = [24, 20, 12];
        const comp_pos = [36, 40, 46];
        this.registrants.take(1).subscribe( regs => {
            const doc = new jsPDF();
            doc.setFont('helvetica');
            // doc.addFileToVFS('Ubuntu-Regular', this.ubuntu_regular);
            // doc.addFont('Ubuntu-Regular', 'Ubuntu', 'normal', 'StandardEncoding');
            // doc.addFileToVFS('Ubuntu-Bold', this.ubuntu_bold);
            // doc.addFont('Ubuntu-Bold', 'Ubuntu', 'bold', 'StandardEncoding');
            // doc.addFileToVFS('NettoOT', this.netto_regular);
            // doc.addFont('NettoOT', 'Netto', 'normal', 'StandardEncoding');

            const filename = this.letterNumberOnly(title + '_NameBadges');
            regs.forEach((reg, i) => {
                const ori_x = i % 2 == 0 ? 15 : 15 + width;
                const ori_y = Math.floor((i % 10) / 2) * height + 11;
                doc.rect(ori_x, ori_y, width, height);
                doc.setFontType('normal');
                doc.setFontSize(30);
                const fullname = doc.splitTextToSize(reg.firstName + ' ' + reg.lastName, 80);
                doc.text(ori_x + 45, ori_y + name_pos[fullname.length - 1], fullname, null, null, 'center');

                // doc.setFont('helvetica');
                doc.setFontType('bold');
                doc.setFontSize(16);
                const company = doc.splitTextToSize(reg.company, 80);
                doc.text(ori_x + 45, ori_y + comp_pos[fullname.length - 1], company, null, null, 'center');
                if (i % 10 == 9 && regs.length != i + 1) {
                    doc.addPage();
                }
            });
            doc.save(filename);
        });

    }
    forData(title, show_scanId:boolean = false) {
        let csv = '"First name","Last name","Email","Company","Phone","Invited","Attending","Ticket Sent","Checked in","Time checked in","Walk-in"\n';
        if(show_scanId) csv = '"ID",' + csv;
        const filename = this.letterNumberOnly(title + '_Data') + '.csv';
        this.registrants.take(1).subscribe( regs => {
            regs.forEach( reg => {
                if(show_scanId) csv += `"${reg.scanId}",`;
                csv += `"${reg.firstName || ''}","${reg.lastName || ''}","${reg.email}","${reg.company || ''}","${reg.phone || ''}",` +
                `"${reg.inviteSent==0 ? '' : this.DDate(reg.inviteSent)}","${this.rsvp(reg.attending)}",` +
                `"${reg.ticketSent==0 ? '' : this.DDate(reg.ticketSent)}",` +
                `"${reg.checkedIn==0 ? '' : 'Yes'}",` +
                `"${reg.checkedIn==0 ? '' : this.DDate(reg.checkedIn*1000)}",` +
                `"${reg.walkin ? 'Yes' : 'No'}"\n`;
            });
            this.download(filename, csv);
        });

    }
    async forReport(title, regs) {

        let data = {
            a: [],
            w: [],
            n: [],
            r: []
        };
        regs.forEach(x => {
            let temp = { name: x.firstName + ' ' + x.lastName, company: x.company ? x.company : '' };
            if (x.attending == 'accepted') {
                if (x.walkin > 0) {
                    data.w.push(temp);
                } else if (x.checkedIn > 0) {
                    data.n.push(temp);
                } else {
                    data.a.push(temp);
                }
            } else {
                data.r.push(temp);
            }
        });
        let count = [regs.length, regs.length - data.r.length, data.a.length + data.w.length, data.w.length, data.n.length, data.r.length]; // invited, accepted, attended, walked-in, no-show, reject

        try {
            const doc = new jsPDF('p', 'pt', 'a4'); // [595.28,841.89]
            doc.addFileToVFS('NettoOT', this.fonts.NettoOT);
            doc.addFont("NettoOT", "NettoOT", "normal", "WinAnsiEncoding");

            let logo = await this.getImage('/assets/Checkit_RGB_750px.png');
            doc.setFont('NettoOT');

            // page 1
            let pages = 1;

            doc.setFillColor(235, 240, 244);
            doc.rect(0, 0, 595.28, 100, 'F');
            doc.addImage(logo, 237.64, 34, 120, 32);

            doc.setFontSize(40);
            doc.text(297.64, 170, title, 'center');

            doc.setFontSize(16);
            doc.setTextColor(142, 142, 142);
            doc.text(297.64, 210, 'EVENT REPORT', 'center');

            doc.setFontSize(60);
            doc.setTextColor(45, 45, 45);
            doc.text(297.64, 335, count[0] + '', 'center');
            doc.text(148.82, 490, count[1] + '', 'center');
            doc.text(446.46, 490, count[2] + '', 'center');
            doc.text(148.82, 670, count[3] + '', 'center');
            doc.text(446.46, 670, count[4] + '', 'center');

            doc.setFontSize(16);
            doc.text(297.64, 280, 'YOU INVITED', 'center');
            doc.text(297.64, 360, 'PEOPLE', 'center');
            doc.text(148.82, 510, doc.splitTextToSize('PEOPLE SAID THEY WOULD COME', 160), 'center');
            doc.text(446.46, 510, 'PEOPLE ATTENDED', 'center');
            doc.text(148.82, 615, 'YOU HAD', 'center');
            doc.text(446.46, 615, 'YOU HAD', 'center');
            doc.text(148.82, 690, 'WALK-INS', 'center');
            doc.text(446.46, 690, 'NO-SHOWS', 'center');

            doc.setFontSize(14);
            doc.setTextColor(142, 142, 142);
            doc.text(148.82, 546, doc.splitTextToSize('(' + Math.floor(count[1] / count[0] * 1000) / 10 + '% OF THOSE INVITED)', 160), 'center');
            doc.text(446.46, 530, doc.splitTextToSize('(' + Math.floor(count[2] / count[1] * 1000) / 10 + '% OF THOSE WHO SAID THEY WOULD COME)', 160), 'center');
            doc.text(148.82, 710, doc.splitTextToSize('(' + Math.floor(count[3] / count[2] * 1000) / 10 + '% OF ATTENDANCE)', 160), 'center');
            doc.text(446.46, 710, doc.splitTextToSize('(' + Math.floor(count[4] / count[1] * 1000) / 10 + '% OF THOS WHO SAID THEY WOULD COME)', 160), 'center');

            // page 2 and more
            let types = [
                { top: 0, left: 45, name: 'ATTENDED:', name_len: 65, data: data.a, count: count[2] },
                { top: 15, left: 75, name: 'WALK-INS:', name_len: 60, data: data.w, count: count[3] },
                { top: 25, left: 45, name: 'NO-SHOWS:', name_len: 65, data: data.n, count: count[4] },
                { top: 25, left: 45, name: "RSVP'D NO:", name_len: 65, data: data.r, count: count[5] },
            ];
            let start_height = 40;
            let print_height = 780;
            let max_height = 780;

            types.forEach(x => {

                print_height += x.top;
                if (print_height + 55 > max_height) {
                    doc.addPage();
                    pages += 1;
                    print_height = start_height;
                }

                print_height += 15;
                doc.setFontSize(14);
                doc.setTextColor(45, 45, 45);
                doc.text(x.left, print_height, x.name);
                doc.setTextColor(142, 142, 142);
                doc.text(x.left + x.name_len, print_height, '(' + x.count + ')');
                print_height += 10;

                doc.setFontSize(12);
                doc.setTextColor(45, 45, 45);
                x.data.forEach((user, i, a) => {
                    if (print_height + 31 > max_height) {
                        if (i != 0) {
                            doc.setFillColor(142, 142, 142);
                            doc.rect(x.left, print_height, 550.28 - x.left, 1, 'F');
                        }
                        doc.addPage();
                        pages += 1;
                        print_height = start_height;
                    }
                    if (i % 2 == 0) {
                        doc.setFillColor(235, 240, 244);
                        doc.rect(x.left, print_height, 550.28 - x.left, 32, 'F');
                    }
                    doc.setFillColor(142, 142, 142);
                    doc.rect(x.left, print_height, 550.28 - x.left, 1, 'F');

                    doc.text(x.left + 15, print_height + 21, i + 1 + '');
                    doc.text(x.left + 75, print_height + 21, user.name);
                    doc.text(x.left + 255, print_height + 21, user.company);

                    print_height += 31;
                    if (i == a.length - 1) {
                        doc.setFillColor(142, 142, 142);
                        doc.rect(x.left, print_height, 550.28 - x.left, 1, 'F');
                    }
                });

            });

            for(let i = pages; i > 0; i--) {
                doc.setPage(i);
                doc.setFillColor(235, 240, 244);
                doc.rect(0, 800, 595.28, 41.89, 'F');
                doc.addImage(logo, 15, 813.95, 52.5, 14);
                doc.setFontSize(10);
                doc.text(530, 825.95, i + ' of ' + pages);
            }

            const filename = this.letterNumberOnly(title + '_NameReport');
            doc.save(filename);
         } catch(e) {
            console.log(e);
         }

    }
    private getImage(imagePath) {
        return new Promise(function(resolve, reject) {
            let img = new Image();
            img.onload = function() {
                resolve(this);
            };
            img.src = imagePath;
        })
    }
    private download(filename, text) {
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
    private letterNumberOnly(string) {
        return string.replace(/\W/g, '');
    }
    private DDate(d) {
        const date = new Date(d);
        return new DatePipe('en-US').transform(date, 'medium');
    }
    private rsvp(attending) {
        switch (attending) {
            case 'accepted':
                return 'Yes';
            case 'declined':
                return 'No';
            default:
                return '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/core/download.service.ts